import Cookies from 'js-cookie';

import { removeUndefined } from './utils';

export const getStoredCriteria = (key) => {
  let storedCriteria = null;
  try {
    storedCriteria = sessionStorage.getItem(key) ?? Cookies.get(key);
    storedCriteria = JSON.parse(storedCriteria);
  } catch (error) {
    //
  }

  return storedCriteria;
};

export const setStoredCriteria = (key, criteria) => {
  const storedCriteria = getStoredCriteria(key);
  const mergedCriteria =
    // refactor: criteria should always be an object and remove condition
    typeof criteria === 'string'
      ? criteria
      : removeUndefined({
          ...(storedCriteria || {}),
          ...criteria,
        });
  const stringifiedCriteria = typeof mergedCriteria === 'string' ? mergedCriteria : JSON.stringify(mergedCriteria);

  sessionStorage.setItem(key, stringifiedCriteria);
  Cookies.set(key, stringifiedCriteria);
};
